import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import thumbUp from 'assets/icons/thumbs-up.svg';
import './style.scss';

const Congrats = () => {
  const workflow = useSelector((state) => state.workflow);

  useEffect(() => {
    window.scrollTo(0, 0);
    window.top.postMessage(
      {
        isSuccess: true,
      },
      '*'
    );
  }, []);

  return (
    <section className="container section">
      <div className={cn('grid-container fluid', 'borrowers-message')}>
        <div className="grid-container">
          <div className="grid-x grid-margin-x max-limited">

            <div className="cell small-12 large-8 large-offset-2">
              {workflow.entityId ? (
                <p className="text-left p-large">
                  <b>Merchant ID:</b>
                  {' '}
                  {workflow.entityId}
                </p>
              ) : null}
              <img src={thumbUp} alt="congrats" />
              <h2>
                Congratulations!
                <br />
                Your application has been successfully submitted!
              </h2>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Congrats;
